import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  private isBrowser: boolean = typeof window !== 'undefined';

  setItem(key: string, value: any): void {
    if (this.isBrowser) {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      console.warn('Local Storage is not available.');
    }
  }

  getItem(key: string): any {
    if (this.isBrowser) {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } else {
      console.warn('Local Storage is not available.');
      return null;
    }
  }

  getItemWithOutParse(key: string): string | null{
    if (this.isBrowser) {
      const item = localStorage.getItem(key);
      return item ? item : null;
    } else {
      console.warn('Local Storage is not available.');
      return null;
    }
  }

  removeItem(key: string): void {
    if (this.isBrowser) {
      localStorage.removeItem(key);
    } else {
      console.warn('Local Storage is not available.');
    }
  }

  clear(): void {
    if (this.isBrowser) {
      localStorage.clear();
    } else {
      console.warn('Local Storage is not available.');
    }
  }
}
